/* 携程客户的接口 */
export default {
    ctripLogin: {
        path: '/ump/v1/p/ctrip/users/signup',
        method: 'post',
        noAuth: true,
    },
    ctripLoginWithCode: {
        path: '/ump/v1/p/ctrip/users/signin',
        method: 'post',
        noAuth: true,
    },
    ctripRegisterWithCode: {
        path: '/ump/v1/p/ctrip/users/binding',
        method: 'post',
        noAuth: true,
    },
};
